import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { RouterModule } from '@angular/router'

// export let AppRouterModule = RouterModule.forRoot(APP_ROUTES, {
//   useHash: true,
//   initialNavigation: 'disabled'
// });

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
